/**
 * Template utility functions for managing message templates
 */
import defaultTemplates from '../config/messageTemplatesConfig';
import { getMessageTemplates, updateMessageTemplates, resetMessageTemplates } from '../services/templatesApi';

/**
 * Initialize templates with defaults if needed
 * @returns {Promise<Object>} The initialized templates
 */
export const initializeTemplates = async () => {
  try {
    // Try to get templates from server
    // console.log('Initializing templates');
    const templates = await getMessageTemplates();
    
    if (templates && Object.keys(templates).length > 0) {
      // console.log('Templates found on server');
      return templates;
    }
    
    // If no templates found, create with defaults
    console.log('No templates found, creating defaults');
    const newTemplates = await updateMessageTemplates(defaultTemplates);
    return newTemplates;
  } catch (error) {
    console.error('Failed to initialize templates:', error);
    // Return defaults if server operations fail
    return defaultTemplates;
  }
};

/**
 * Validates template data structure
 * @param {Object} templates - The templates object to validate
 * @returns {boolean} Whether the templates are valid
 */
export const validateTemplates = (templates) => {
  if (!templates || typeof templates !== 'object') {
    console.error('Templates invalid: not an object', templates);
    return false;
  }
  
  // Check for required fields
  const requiredFields = [
    'remarksSectionTitle',
    'nextActionSectionTitle',
    'quotationNextAction',
    'invoicePaymentInstruction'
  ];
  
  for (const field of requiredFields) {
    if (!templates[field]) {
      console.error(`Templates invalid: missing required field ${field}`);
      return false;
    }
  }
  
  return true;
};

/**
 * Safely get template value with fallback
 * @param {Object} templates - The templates object
 * @param {string} key - The template key to retrieve
 * @param {string} defaultValue - Default value if key not found
 * @returns {string} The template value or default
 */
export const getTemplateValue = (templates, key, defaultValue = '') => {
  if (!templates || !templates[key]) {
    return defaultValue;
  }
  return templates[key];
};
